import React from "react";
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';

const About = () => {
  return (
        <div>
        <Bar/>
  {/* ======= Portfolio Section ======= */}
  <section id="portfomnd" className="portfolio" data-aos="fade-up">
    <div className="container">
      <div className="section-header">
        <h2>About Us</h2>
        <p>
        The site provides some models for investors who have capital and want to enter the field of business, and there are a number of models that the investor can choose from, and the models have been divided into categories of capital. The investment models were filtered in the form of price categories to facilitate the selection of the appropriate project based on the price.
        </p>
      </div>
    </div>
   <div className="container-fluid" data-aos="fade-up" data-aos-delay={200}>
     <p>
      PPPP
     </p>
   </div>
  </section>
  {/* End Portfolio Section */}
        <Footer/>
        </div>
  );
};

export default About;